import { configurationForToken } from "../CommonConstants";
import apiClient from "./apiClient";

const addIncidence = (token, incidence) => {
  const config = configurationForToken(token);
  return apiClient.post("/admin/incidence/create", incidence, config);
};

const getVehicleIncidence = (token, vehicleId) => {
  const config = configurationForToken(token);
  return apiClient.get(`/admin/incidence/vehicle/${vehicleId}`, config);
};

const editIncidence = (token, incidence, id) => {
  const config = configurationForToken(token);
  return apiClient.put(`/admin/incidence/${id}`, incidence, config);
};

const deleteIncidence = (token, incidenceId) => {
  const config = configurationForToken(token);
  return apiClient.delete(`/admin/incidence/${incidenceId}`, config);
};

export default {
  addIncidence,
  getVehicleIncidence,
  editIncidence,
  deleteIncidence
};



// WEBPACK FOOTER //
// ./src/Services/IncidenceService.js